import { Component, OnInit } from "@angular/core";
import { AppService, AuthenticationService } from "../_services/index";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-dashboard",
  templateUrl: "./full-layout.component.html",
})
export class FullLayoutComponent implements OnInit {
  userData = {
    profileName: "",
    image: "",
  };

  openMenuIndex: number | null = null;
  openCiiMenuIndex: number | null = null;

  showHeaderFooter: boolean = true;
  getToken: any;
  showDNClass: boolean = false;
  setting = { image: "" };

  constructor(
    public authenticationService: AuthenticationService,
    private dataService: AppService,
    private route: ActivatedRoute,
    private router: Router
  ) {}
  wepMenuList: any = [];
  ciiMenuList: any = [];
  public disabled = false;
  public status: { isopen: boolean } = { isopen: false };

  public toggled(open: boolean): void {}

  ngOnInit(): void {
    setTimeout(() => {
      this.showDNClass = true;
    }, 20);

    this.getToken = window.localStorage.getItem("currentUser");
    this.dataService
      .checkLogin(this.getToken)
      .pipe()
      .subscribe((data) => {
        if (data["user"]) {
          this.userData = {
            profileName: data["user"].name,
            image: data["user"].image,
          };

          this.dataService
            .getMenu()
            .pipe()
            .subscribe((data) => {
              this.wepMenuList = data["wep_menu"].map((item: any) => {
                if (item.children && item.children.length > 0) {
                  item.children = item.children.map((sub: any) => {
                    if (sub.route === "user") {
                      sub.hiddenRoutes = ["user-role/:id", "user-permission"];
                    }
                    if (sub.route === "mentorship-metrics") {
                      sub.hiddenRoutes = [
                        "mentorship-all-mentors",
                        "mentorship-approved-mentors",
                        "mentorship-pending-mentors",
                        "mentorship-rejected-mentors",
                        "mentorship-req-accept-by-mentor",
                        "mentorship-req-sent-by-mentee",
                        "mentorship-pending-req-by-mentor",
                        "mentorship-rejected-req-by-mentor",
                        "mentorship-meetings",
                        "mentorship-successful-meetings",
                        "mentorship-hours-received",
                        "mentorship-repeated-meetings",
                        "mentorship-logins-by-mentors",
                        "mentorship-smart-match",
                        "mentorship-mentee-feedback",
                        "mentorship-mentor-feedback",
                        "mentorship-most-search-mentors",
                        "mentorship-mentee-ratings",
                        "mentorship-mentor-ratings",
                      ];
                    }
                    if (sub.route === "member") {
                      sub.hiddenRoutes = ["member-view/:id", "user-permission"];
                    }
                    return sub;
                  });
                }
                return item;
              });

              this.ciiMenuList = data["cii_menu"];

              this.setData();
              this.setActiveMenu();
              this.setActiveCiiMenu();
            });
          }
       });
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.setActiveMenu();
        this.setActiveCiiMenu();
      });

    let settingData = JSON.parse(localStorage.getItem("setting"));
    this.setting = { image: settingData.image };
  }

  toggleDropdown(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? null : index;
    this.openCiiMenuIndex = null;
  }

  toggleCiiDropdown(index: number) {
    this.openCiiMenuIndex = this.openCiiMenuIndex === index ? null : index;
    this.openMenuIndex = null;
  }

  isActive(sub: any): boolean {
    const currentUrl = this.router.url.split("?")[0];

    // Direct match
    if (currentUrl === "/" + sub.route) return true;

    // Hidden routes match
    if (sub.hiddenRoutes && sub.hiddenRoutes.length > 0) {
      return sub.hiddenRoutes.some((h: string) => {
        if (h.includes(":id")) {
          const base = "/" + h.replace("/:id", "");
          return currentUrl.startsWith(base + "/");
        } else {
          return currentUrl === "/" + h;
        }
      });
    }

    return false;
  }

  setActiveMenu() {
    const currentUrl = this.router.url.split("?")[0];
    this.openMenuIndex = null;

    if (this.wepMenuList) {
      this.wepMenuList.forEach((item: any, i: number) => {
        if (item.children && item.children.length > 0) {
          const found = item.children.find((sub: any) => this.isActive(sub));
          if (found) {
            this.openMenuIndex = i; 
          }
        } else if (currentUrl === "/" + item.route) {
          this.openMenuIndex = null;
        }
      });
    }
  }

  // setActiveMenu() {
  //   const currentUrl = this.router.url.split("?")[0];
  //   this.openMenuIndex = null;

  //   if (this.wepMenuList) {
  //     this.wepMenuList.forEach((item: any, i: number) => {
  //       if (item.children && item.children.length > 0) {
  //         const found = item.children.find((sub: any) => {
  //           const subRoute = "/" + sub.route;

  //           // ✅ Direct match (exact or child routes)
  //           if (currentUrl === subRoute || currentUrl.startsWith(subRoute + "/")) {
  //             return true;
  //           }

  //           // ✅ Hidden route match
  //           if (sub.hiddenRoutes && sub.hiddenRoutes.length > 0) {
  //             return sub.hiddenRoutes.some(
  //               (hidden: string) =>
  //                 currentUrl === "/" + hidden || currentUrl.startsWith("/" + hidden + "/")
  //             );
  //           }

  //           return false;
  //         });

  //         if (found) {
  //           this.openMenuIndex = i; // parent active
  //           this.openCiiMenuIndex = null;
  //         }
  //       } else if (
  //         currentUrl === "/" + item.route ||
  //         currentUrl.startsWith("/" + item.route + "/")
  //       ) {
  //         this.openMenuIndex = null;
  //         this.openCiiMenuIndex = null;
  //       }
  //     });
  //   }
  // }

  isSubActive(sub: any): boolean {
    const currentUrl = this.router.url.split("?")[0];

    // Direct match (exact or child paths)
    if (
      currentUrl === "/" + sub.route ||
      currentUrl.startsWith("/" + sub.route + "/")
    ) {
      return true;
    }

    // Hidden route match
    if (sub.hiddenRoutes && sub.hiddenRoutes.length > 0) {
      return sub.hiddenRoutes.some(
        (hidden: string) =>
          currentUrl === "/" + hidden ||
          currentUrl.startsWith("/" + hidden + "/")
      );
    }

    return false;
  }

  setActiveCiiMenu() {
    const currentUrl = this.router.url.split("?")[0];
    this.openCiiMenuIndex = null;

    if (this.ciiMenuList) {
      this.ciiMenuList.forEach((item: any, i: number) => {
        if (item.children && item.children.length > 0) {
          const found = item.children.find(
            (sub: any) => currentUrl === "/" + sub.route
          );
          if (found) {
            this.openCiiMenuIndex = i; 
          }
        } else if (currentUrl === "/" + item.route) {
          this.openCiiMenuIndex = null;
        }
      });
    }
  }

  setData() {
    const dataArray = this.wepMenuList;
    this.dataService.setDataArray(dataArray);
  }

  public logout(): void {
    this.authenticationService.logout();
  }

  checkRoute() {
    const currentUrl = this.router.url;
    const urlTree = this.router.parseUrl(currentUrl);
    const queryParams = urlTree.queryParams;
    if (currentUrl.startsWith("/mentor-verification") && queryParams["q1"]) {
      this.showHeaderFooter = false;
    } else {
      this.showHeaderFooter = true;
    }
  }
}
